<template>
  <div class="section-header mb-5" :class="{ 'text-center': centered }">
    <p v-if="eyebrow" class="section-header__eyebrow mb-3">{{ eyebrow }}</p>
    <h2 class="nm-section-title mb-3">{{ title }}</h2>
    <p v-if="lead" class="nm-section-lead" :class="{ 'mx-auto': centered }">{{ lead }}</p>
  </div>
</template>

<script setup>
defineProps({
  eyebrow: { type: String, default: '' },
  title: { type: String, required: true },
  lead: { type: String, default: '' },
  centered: { type: Boolean, default: false },
})
</script>

<style scoped>
.section-header__eyebrow {
  font-size: 0.78rem;
  font-weight: var(--nm-font-weight-semibold);
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: var(--nm-accent);
}
</style>